import { autoinject } from 'aurelia-dependency-injection';
import { bindable, bindingMode } from 'aurelia-framework';
import { FeatureInfo } from '../../services/organization-info';

@autoinject
export class FeatureStatus {

    constructor() {
       
    }

     
    @bindable({ defaultBindingMode: bindingMode.oneWay })  feature: FeatureInfo;
   

    bind() {
        console.log(`bind feature-status pane`, this.feature.featureName);
        
    }
}


// WEBPACK FOOTER //
// ./ClientApp/app/components/licensing-overview/feature-status.ts